module.exports = __webpack_public_path__ + "assets/alysia-small.43b8e287.svg";